import { useTranslation } from 'react-i18next'

export default function SkipToContent() {
  const { t } = useTranslation()
  return (
    <a
      href="#main-content"
      className="sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:w-auto focus:h-auto focus:px-4 focus:py-2 focus:m-0 focus:overflow-visible focus:[clip:auto] focus:bg-primary focus:text-white focus:rounded-xl focus:font-semibold focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary dark:focus:ring-offset-background-dark"
    >
      {t('a11y.skipToContent')}
    </a>
  )
}
